const enums = {
  workspaceTypes: { organization: 1, personal: 2, shared: 3, search: 0 },
};
export default enums;
export { enums };
